// Brand-level data capabilities for the brand-page editors. A section or page whose required capability
// is KNOWN false is not offered; only flags we can determine from the brand are set false here.
export function resolveBrandCapabilities(brand) {
    var caps = {};
    if (!brand) {
        return caps;
    }
    var instantGames = brand.activeBrandInstantGames || brand.brandInstantGames || [];
    caps.instantGames = instantGames.length > 0;
    // NOTE: `bundles` is deliberately NOT set here. brand.bundles is not loaded with the brand - the
    // Bundles step fetches it separately - so reading it reports "no bundles" for every brand. Hosts
    // resolve it from GetBundlesByBrand (the same lobby feed the runtime nav uses) and apply it after.
    var op = brand.operator;
    var syndicateOperatorMargin = brand.syndicatesOperatorMargin || (op ? op.syndicatesOperatorMargin : 0);
    var syndicatePlatformMargin = brand.syndicatesPlatformMargin || (op ? op.syndicatesPlatformMargin : 0);
    caps.syndicate = !!(syndicateOperatorMargin && syndicatePlatformMargin);
    return caps;
}
